import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "form-custom mt-2" }
const _hoisted_2 = { class: "details-panel-content" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "p-field" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = { class: "fw-bold" }
const _hoisted_7 = { class: "bt-icon bt-icon--xs" }
const _hoisted_8 = { class: "ml-2" }
const _hoisted_9 = {
  key: 0,
  class: "no-badge text-center"
}
const _hoisted_10 = { class: "text-gray" }
const _hoisted_11 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_12 = { class: "text-gray" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_BadgeItem = _resolveComponent("BadgeItem")
  const _component_AddBadgePage = _resolveComponent("AddBadgePage")
  const _component_DialogAddBadge = _resolveComponent("DialogAddBadge")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        (_ctx.isEdit)
          ? (_openBlock(), _createBlock("span", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _createVNode("span", _hoisted_5, [
                  _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("entrancePlant.associatedBadges")), 1),
                  _createVNode(_component_Button, {
                    disabled: _ctx.addButtonDisabled||_ctx.disabled,
                    class: "p-button-rounded p-button-outlined ml-auto",
                    onClick: _ctx.handleAddBadgeGuest
                  }, {
                    default: _withCtx(() => [
                      _createVNode("span", _hoisted_7, [
                        _createVNode(_component_InlineSvgScoped, {
                          src: 
                                        require(`@/assets/images/icons/icon-plus-outline.svg`)
                                    ,
                          "aria-label": "icon-grid"
                        }, null, 8, ["src"])
                      ]),
                      _createVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("AppResource.Add")), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"])
                ])
              ]),
              (!_ctx.badge)
                ? (_openBlock(), _createBlock("div", _hoisted_9, [
                    _createVNode("span", _hoisted_10, _toDisplayString(_ctx.noBadgeText[0]), 1),
                    _hoisted_11,
                    _createVNode("span", _hoisted_12, _toDisplayString(_ctx.noBadgeText[1]), 1)
                  ]))
                : (_openBlock(), _createBlock(_component_BadgeItem, {
                    key: 1,
                    offline: _ctx.disabled,
                    badgeTab: "",
                    badge: _ctx.badge,
                    class: "m-3 py-2",
                    onDeleteBadge: _ctx.handleDeleteBadge
                  }, null, 8, ["offline", "badge", "onDeleteBadge"]))
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isEdit)
          ? (_openBlock(), _createBlock(_component_AddBadgePage, {
              key: 1,
              gateGuest: _ctx.editingGuest,
              badgesList: _ctx.badgesList,
              plantBadges: _ctx.plantBadges,
              onAddBadge: _ctx.addBadge,
              onRemoveBadge: _ctx.removeBadge
            }, null, 8, ["gateGuest", "badgesList", "plantBadges", "onAddBadge", "onRemoveBadge"]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.isVisibleAddBadgeGuest)
      ? (_openBlock(), _createBlock(_component_DialogAddBadge, {
          key: 0,
          guestBadge: "",
          "is-visible": _ctx.isVisibleAddBadgeGuest,
          plantBadges: _ctx.plantBadges,
          fromGuestTab: _ctx.editingGuest,
          onAddBadgeTab: _ctx.addBadge,
          onHideDialog: _ctx.handleAddBadgeGuest
        }, null, 8, ["is-visible", "plantBadges", "fromGuestTab", "onAddBadgeTab", "onHideDialog"]))
      : _createCommentVNode("", true)
  ], 64))
}